"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const staticColors = {
    coolGrey50: '#FAFBFC',
    coolGrey100: '#F2F5F7',
    coolGrey200: '#E6E9ED',
    coolGrey300: '#D0D3D9',
    coolGrey400: '#A9AFBA',
    coolGrey500: '#7E8594',
    coolGrey600: '#515B6E',
    coolGrey700: '#3C475B',
    coolGrey800: '#1E293D',
    coolGrey900: '#0C1018',
    neutralGrey50: '#fafafa',
    neutralGrey100: '#f6f6f6',
    neutralGrey150: '#f5f5f5',
    neutralGrey200: '#e9e9e9',
    neutralGrey300: '#d2d2d2',
    neutralGrey400: '#b7b7b7',
    neutralGrey500: '#929292',
    neutralGrey600: '#686969',
    neutralGrey700: '#434443',
    neutralGrey800: '#282827',
    neutralGrey850: '#151515',
    neutralGrey900: '#090808',
    neutralGrey950: '#040404',
    domainGreen50: '#FAFCF8',
    domainGreen100: '#D6E8CA',
    domainGreen200: '#AED59A',
    domainGreen300: '#7FC468',
    domainGreen400: '#4AB535',
    domainGreen500: '#0EA800',
    domainGreen600: '#1B7B10',
    domainGreen700: '#205519',
    domainGreen800: '#1F351C',
    domainGreen900: '#181C18',
    canary50: '#FFFCF0',
    canary100: '#FFFAC6',
    canary200: '#FFF399',
    canary300: '#FFE976',
    canary400: '#FFDB59',
    canary500: '#FFCA44',
    canary600: '#9D6525',
    canary700: '#8B4D1D',
    canary800: '#603415',
    canary900: '#3F252C',
    lobster50: '#FFF1EB',
    lobster100: '#FCCBB9',
    lobster200: '#F9A489',
    lobster300: '#F67B5A',
    lobster400: '#F3502C',
    lobster500: '#D93013',
    lobster600: '#A9200E',
    lobster700: '#7A120A',
    lobster800: '#4A0806',
    lobster900: '#1A0202',
    ocean50: '#F2F5FF',
    ocean100: '#CEDCFF',
    ocean200: '#A9C3FF',
    ocean300: '#7FABFF',
    ocean400: '#4794FF',
    ocean500: '#147AE2',
    ocean600: '#1F5DA9',
    ocean700: '#1F4274',
    ocean800: '#192843',
    ocean900: '#0C1018',
    domainBlue50: '#EBECF1',
    domainBlue100: '#BABECF',
    domainBlue200: '#8B92AE',
    domainBlue300: '#5D698D',
    domainBlue400: '#2E426D',
    domainBlue500: '#142C54',
    domainBlue600: '#142341',
    domainBlue700: '#121B2F',
    domainBlue800: '#0E121E',
    domainBlue900: '#04060C',
    blurple50: '#F3EFFD',
    blurple100: '#D4C6F8',
    blurple200: '#B39FF1',
    blurple300: '#9078EA',
    blurple400: '#6753E2',
    blurple500: '#483BC5',
    blurple600: '#3B2F94',
    blurple700: '#2D2367',
    blurple800: '#1F183C',
    blurple900: '#0E0916',
    aqua50: '#F0F8F7',
    aqua100: '#C8E8E4',
    aqua200: '#9FD7D1',
    aqua300: '#74C6BE',
    aqua400: '#3DB5AC',
    aqua500: '#0F9991',
    aqua600: '#1A746E',
    aqua700: '#1A514D',
    aqua800: '#16312E',
    aqua900: '#0A1312',
    oak50: '#FBF9F5',
    oak100: '#F7F3EC',
    oak200: '#F3EEE3',
    oak300: '#EFE8D9',
    oak400: '#EBE3D0',
    oak500: '#C0BAAB',
    oak600: '#918C81',
    oak700: '#65615A',
    oak800: '#3B3A36',
    oak900: '#161615',
    sage50: '#F5FBF5',
    sage100: '#DBEFDD',
    sage200: '#C2E3C6',
    sage300: '#A8D8AE',
    sage400: '#8ECC97',
    sage500: '#72B07D',
    sage600: '#58855F',
    sage700: '#3F5C43',
    sage800: '#273629',
    sage900: '#101410',
    sandstone50: '#FAF8F6',
    sandstone100: '#EEE8E0',
    sandstone200: '#E2D8CB',
    sandstone300: '#D6C8B5',
    sandstone400: '#CAB8A0',
    sandstone500: '#AE9C86',
    sandstone600: '#837666',
    sandstone700: '#5B5347',
    sandstone800: '#36312B',
    sandstone900: '#141311',
    dusk50: '#FFFAF8',
    dusk100: '#FFEFE6',
    dusk200: '#FEE3D4',
    dusk300: '#FDD7C2',
    dusk400: '#FBCCB1',
    dusk500: '#DDB095',
    dusk600: '#A68571',
    dusk700: '#725C4F',
    dusk800: '#42362F',
    dusk900: '#181412',
    forest50: '#F5F8F6',
    forest100: '#C2D4C9',
    forest200: '#90B09E',
    forest300: '#5F8D74',
    forest400: '#2D6C4D',
    forest500: '#055133',
    forest600: '#0D3F28',
    forest700: '#0F2E1F',
    forest800: '#0D1D15',
    forest900: '#040B07',
    sriracha50: '#FFF7F8',
    sriracha100: '#FFC6C7',
    sriracha200: '#FF9494',
    sriracha300: '#FF6763',
    sriracha400: '#FF5940',
    sriracha500: '#FF5328',
    sriracha600: '#BB4D31',
    sriracha700: '#7F4132',
    sriracha800: '#4C312A',
    sriracha900: '#221B19',
    slate50: '#F8FAFB',
    slate100: '#C9D8DF',
    slate200: '#9CB2C1',
    slate300: '#718AA1',
    slate400: '#48607F',
    slate500: '#22365A',
    slate600: '#202D44',
    slate700: '#1B222F',
    slate800: '#14181D',
    slate900: '#0B0C0E',
    creYellow50: '#FFFBE6',
    creYellow100: '#FFF2B8',
    creYellow200: '#FFEA8A',
    creYellow300: '#FFE25C',
    creYellow400: '#FFDA2E',
    creYellow500: '#FFD200',
    creYellow600: '#B39214',
    creYellow700: '#735E1D',
    creYellow800: '#3E341B',
    creYellow900: '#14120D',
    crePurple50: '#F6F4FB',
    crePurple100: '#D5CCEC',
    crePurple200: '#B3A4DD',
    crePurple300: '#927CCD',
    crePurple400: '#7054BE',
    crePurple500: '#4F2CAF',
    crePurple600: '#402D7F',
    crePurple700: '#312854',
    crePurple800: '#201D2F',
    crePurple900: '#0D0D10',
    pomegranate50: '#FFF9F9',
    pomegranate100: '#FFEBF1',
    pomegranate200: '#FFCEDA',
    pomegranate300: '#FF7788',
    pomegranate400: '#FF4963',
    pomegranate500: '#E81043',
    pomegranate600: '#CB143F',
    pomegranate700: '#A20B2E',
    pomegranate800: '#65091E',
    pomegranate900: '#0E0404',
    navy50: '#FAFCFD',
    navy100: '#F1F5FA',
    navy200: '#E3E9F2',
    navy300: '#CCD4E3',
    navy400: '#A0AFCB',
    navy500: '#7285A5',
    navy600: '#5F7297',
    navy700: '#314B7B',
    navy800: '#0B2047',
    navy900: '#0A0B0D',
    lavender50: '#F8F5F9',
    lavender100: '#E0D5E7',
    lavender200: '#D1BEDA',
    lavender300: '#B190BE',
    lavender400: '#9F73AC',
    lavender500: '#8D579A',
    lavender600: '#7C3A88',
    lavender700: '#512A71',
    lavender800: '#2B1D58',
    lavender900: '#11143C',
    eucalyptus50: '#F9FAFA',
    eucalyptus100: '#EEF1EF',
    eucalyptus200: '#CCD6D0',
    eucalyptus300: '#A0B1A7',
    eucalyptus400: '#6A8376',
    eucalyptus500: '#4C6A5A',
    eucalyptus600: '#395446',
    eucalyptus700: '#273D31',
    eucalyptus800: '#17251D',
    eucalyptus900: '#070C09',
    wattle50: '#FFFCEE',
    wattle100: '#FFFAE0',
    wattle200: '#FFF7D1',
    wattle300: '#FFF2AD',
    wattle400: '#FFE97B',
    wattle500: '#E5CE63',
    wattle600: '#BBA54B',
    wattle700: '#8B7732',
    wattle800: '#5B4B1B',
    wattle900: '#392601',
    sky50: '#F1F7FC',
    sky100: '#CFE4F3',
    sky200: '#B5D5EC',
    sky300: '#9BC7E6',
    sky400: '#7EB6DF',
    sky500: '#689DC3',
    sky600: '#4E7692',
    sky700: '#375367',
    sky800: '#20313D',
    sky900: '#121415',
    rtaBlue50: '#E1F6FE',
    rtaBlue100: '#B5E9FC',
    rtaBlue200: '#85DAF8',
    rtaBlue300: '#55CCF2',
    rtaBlue400: '#35C1EB',
    rtaBlue500: '#28B7E4',
    rtaBlue600: '#21A7D0',
    rtaBlue700: '#1393B5',
    rtaBlue800: '#057F9C',
    rtaBlue900: '#005D6F',
    white: '#FFFFFF',
    black: '#000000',
};
exports.default = staticColors;
//# sourceMappingURL=static-colors.js.map